
import { defineComponent } from 'vue'
import CloseSvg from '@/components/svgs/CloseSvg.vue'
import LockingButton from '@/components/shared/LockingButton.vue'

export default defineComponent({
  name: 'QuoteApprovalModal',
  components: {
    CloseSvg,
    LockingButton
  },
  props: {
    quoteId: {
      type: Number,
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    }
  },
  emits: ['approved', 'close'],
  mounted() {
    document.body.addEventListener('keyup', this.onKeyup)
  },
  unmounted() {
    document.body.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    onApproveQuoteClicked(): void {
      this.$emit('approved')
    },
    onCloseClicked(): void {
      this.$emit('close')
    },
    onKeyup(e: KeyboardEvent): void {
      if (e.key === 'Escape' || e.key === 'Esc')
        this.onCloseClicked()
    }
  }
})
